<template>
    <div>
        <div class="c_table_wrap">
            <magazine-list-component :magazineType="'recommendSelect'"></magazine-list-component>
        </div>
        <div class="table_wrap">
            <div class="sub_title">등록된 매거진 목록</div>
            <div class="table_search row has_bc">
                <el-row>
                    <el-col :span="12" >
                        <el-button size="small" @click="deleteSelectMagazine(selectedRow)">선택삭제</el-button>
                    </el-col>
                    <el-col :span="12" class="text_right"
                            style="text-align: right;float:right;width: 50%;display: inline-block;">
                    </el-col>
                </el-row>
            </div>
            <el-table
                :data="recommendData"
                style="width: 100%;"
                empty-text="데이터가 없습니다."
                @selection-change="tableSelectChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    class-name="text-center"
                >
                </el-table-column>
                <el-table-column
                    class="table_no"
                    type="index"
                    label="#"
                    width="70"
                    class-name="num"
                    :index="tableIdx"></el-table-column>
                <el-table-column label="제목"  class-name="text_center" width="200"
                                 prop="p_title" cell="p_title"></el-table-column>
                <el-table-column label="등록된 해시태그" class-name="text_center" min-width="250">
                    <template slot-scope="scope">
                        <div v-if="scope.row.Hash.length != 0" style="display: inline-flex;"
                             v-for="data in scope.row.Hash" :key="data.ph_hash">
                            <span style="display: inline-block; font-size: 13px; margin-right: 10px"># {{ data.ph_hash }}</span>
                        </div>
                        <div v-else>
                            <span>-</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="카테고리" width=150 class-name="text_center"
                                 prop="pc_title" cell="pc_title"></el-table-column>
                <el-table-column label="등록일" width=150 class-name="text_center"
                                 prop="created_at" cell="created_at"></el-table-column>
                <el-table-column label="노출여부" class-name="text_center"
                                 prop="p_display" cell="p_display">
                    <template slot-scope="scope">
                        <div v-if="scope.row.p_display === 1">노출</div>
                        <div v-else-if="checkReserve(scope.row)">예약</div>
                        <div v-else>노출중지</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="200"
                    label=""
                    class-name="table_bottons">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="warning"
                            @click="goDetail(scope.$index, scope.row)">상세</el-button>
                        <el-button
                            size="mini"
                            type="danger"
                            @click="deleteSelectMagazine([scope.row])">삭제</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table_search row has_bc">
                <el-row>
                    <el-col :span="12" >
                        <el-button size="small" @click="deleteSelectMagazine(selectedRow)">선택삭제</el-button>
                    </el-col>
                    <el-col :span="12" class="text_right"
                            style="text-align: right;float:right;width: 50%;display: inline-block;">
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import MagazineListComponent from "@/components/magazine/MagazineListComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: "MagazineRecommendComponent",
    mixins: [alertMixins],
    components: {
        MagazineListComponent
    },
    inject: [],
    provide() {
        return{
            returnNowMagazineKey: this.returnNowMagazineKey,
            returnSelectMagazineKeys: this.returnSelectMagazineKeys,
            addSelectMagazine: this.addSelectMagazine,
            deleteSelectMagazine: this.deleteSelectMagazine,
        }
    },
    props: {
        magazineKey: {default: 0},
    },
    data() {
        return{
            recommendData: [],
            recommends: [],
            selectedRow: [],
        }
    },
    beforeRouterEnter() {},
    created() {
        this.getRecommendData();
    },
    mounted() {
        EventBus.$on('saveRecommendMagazine', this.saveRecommend);
    },
    beforeDestroy() {
        EventBus.$off('saveRecommendMagazine')
    },
    destroyed() {},
    computed: {
    },
    methods:{
        returnNowMagazineKey() {
            return this.magazineKey;
        },
        returnSelectMagazineKeys() {
            return this.recommends;
        },
        getRecommendData() {
            let params = {ip: 0, sa: 1, h: 1, pid: this.magazineKey};
            try {
                this.$api.$magazine.getRecommendMagazine(params).then(res => res.Data.Result).then(res => {
                    if(!util.isEmpty(res.List)) {
                        this.recommendData = res.List;
                        util.Array.each(this.recommendData, (obj,index, arr) => {
                            this.recommends.push(obj.p_idx);
                        })
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
        tableSelectChange(rows) {
            this.selectedRow = rows;
        },
        addSelectMagazine(rows) {
            util.Array.each(rows, (row, index, arr) => {
                if(this.recommends.indexOf(row.p_idx) < 0) {
                    this.recommends.push(row.p_idx);
                    this.recommendData.push(row);
                }
            })
        },
        deleteSelectMagazine(rows) {
            util.Array.each(rows, (row, index, arr) => {
                let recommendsIndex = this.recommends.indexOf(row.p_idx);
                let dataIndex = this.recommendData.findIndex(recomm => recomm.p_idx == row.p_idx);
                if(recommendsIndex > -1) {
                    this.recommends.splice(recommendsIndex, 1)
                }
                if(dataIndex > -1) {
                    this.recommendData.splice(dataIndex, 1)
                }
            })
        },
        tableIdx(index) {
            return this.recommendData.length - index;
        },
        checkReserve(row) {
            let now = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            if (row.p_display === 0 && now < row.p_reserve_date) {
                return true;
            }
            return false;
        },
        goDetail(index, row) {
            this.$router.push(`/magazine/${row.p_idx}`);
        },
        _makeParams() {
            let params = {
                p_idx: this.magazineKey,
                recommends: this.recommends,
            }
            return params;
        },
        saveRecommend() {
            if(this.recommends.length > 10) {
                this.errorAlert('추천 매거진은 10개를 초과할 수 없습니다.');
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();
            try {
                this.$api.$magazine.updateRecommendMagazine(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('changeLoading', false);
                    if(res.Info.Type === 1) {
                        this.getRecommendData();
                        this.createAlert({
                            title: '',
                            content: '추천 매거진을 저장하였습니다.',
                            btnText: '확인',
                            hide: () => {
                            }
                        });
                    } else {
                        this.errorAlert(this.writeFailMsg);
                    }
                })
            }catch (e) {
                console.log(e)
                EventBus.$emit('changeLoading', false);
            }
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
